import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'ngx-app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  _requestCodeForm: FormGroup;
  _resetPasswordForm: FormGroup;

  clicked: boolean = false;
  isSendingCode: boolean = false;
  isResettingPassword: boolean = false;
  codeSent: boolean = false;
  baseUrl: string = 'account';

  constructor(private api: ApiService, private router: Router) {
    this._requestCodeForm = new FormGroup({
      Email: new FormControl(null, [Validators.required, Validators.email])
    });
    this._resetPasswordForm = new FormGroup({
      Code: new FormControl(null, [Validators.required]),
      Password: new FormControl(null, [Validators.required]),
      ConfirmPassword: new FormControl(null, [Validators.required])
    });
  }

  ngOnInit() {
  }

  get requestForm() {
    return this._requestCodeForm;
  }

  get resetForm() {
    return this._resetPasswordForm;
  }

  sendCode() {
    this.clicked = true;
    if (this.requestForm.invalid) {
      return;
    }

    this.isSendingCode = true;
    this.api.post(`${this.baseUrl}/forgotpassword`, { Email: this.requestForm.value.Email }).subscribe(() => {
      this.isSendingCode = false;
      this.codeSent = true;
      this.clicked = false;
      Swal.fire({ title: 'Check your email', text: 'We sent you a code to reset your password.' });
    }, (error: any) => {
      this.isSendingCode = false;
      Swal.fire({ title: 'Unable to send reset code', text: error && error.error && error.error.title ? error.error.title : '' });
    });
  }

  resetPassword() {
    this.clicked = true;
    if (this.resetForm.invalid) {
      return;
    }

    if (this.resetForm.value.Password !== this.resetForm.value.ConfirmPassword) {
      Swal.fire({ title: 'Passwords do not match' });
      return;
    }

    this.isResettingPassword = true;
    const payload = {
      Email: this.requestForm.value.Email,
      Code: this.resetForm.value.Code,
      Password: this.resetForm.value.Password,
      ConfirmPassword: this.resetForm.value.ConfirmPassword
    };
    this.api.post(`${this.baseUrl}/resetpassword`, payload).subscribe(() => {
      this.isResettingPassword = false;
      Swal.fire({ title: 'Password reset successfully' }).then(() => {
        this.router.navigateByUrl('auth/login');
      });
    }, (error: any) => {
      this.isResettingPassword = false;
      Swal.fire({ title: 'Unable to reset password', text: error && error.error && error.error.title ? error.error.title : '' });
    });
  }

  backToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
